export function startTokenMonitor() {
    if (sessionStorage.getItem("login") === "true") {
        return setInterval(() => {
            const backendExpiry = new Date(sessionStorage.getItem("expirytime"));
            const activityExpiry = new Date(sessionStorage.getItem("activityExpiryTime"));
            const now = Date.now();
            // Idle timeout logout
            if (now >= activityExpiry) {
                sessionStorage.setItem("sessionExpired", true)
                window.location.href = "/logout";
                return;
            }

            // Backend token will be refreshed by axios interceptor automatically
            // so we don't need to handle here

        }, 3000); // every 3 seconds
    } else {
        return null;
    }
}
